import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpService } from '../http.service';
import { HttpRequestHandler } from '../../models/http-model';
const HEADERS = {};

@Injectable()
export class UpdateProvidersService {
  static ENV = environment;
  constructor(private httpService: HttpService) { }

  public massiveUpdate(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(`${UpdateProvidersService.ENV.environment.API.massive_update_providerdoeq}`, data,  httpRequesthandler);
  }

  public getProcessAll(httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(`${UpdateProvidersService.ENV.environment.API.get_process_tercero_doeq}`,  httpRequesthandler);
  }
  public getProcessId(id: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(`${UpdateProvidersService.ENV.environment.API.get_process_tercero_datail}/${id}`,  httpRequesthandler);
  }

  public proceesUpdate(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.put(`${UpdateProvidersService.ENV.environment.API.process_terc_doeq}`, data,  httpRequesthandler);
  }

  public deleteProcess(pk: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.delete(`${UpdateProvidersService.ENV.environment.API.process_terc_doeq}/${pk}`,  httpRequesthandler);
  }

  public revokeTask(id: string, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.delete(`${UpdateProvidersService.ENV.environment.API.revoke_task_celery_doeq}/${id}`,  httpRequesthandler);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/document/update-providers.service.ts